import { render, staticRenderFns } from "./ClassSelectPage.vue?vue&type=template&id=051fa95c&scoped=true&"
import script from "./ClassSelectPage.vue?vue&type=script&lang=ts&"
export * from "./ClassSelectPage.vue?vue&type=script&lang=ts&"
import style0 from "./ClassSelectPage.vue?vue&type=style&index=0&id=051fa95c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051fa95c",
  null
  
)

export default component.exports